<!--<div class="toolbar"></div>-->
<!--<div class="titlebar" id="header-container"></div>-->
<style class="css"></style>
<div class="screen-reader-content" id="page-loading" aria-hidden="true" aria-live="polite">{{t
  'defaultPageTitle'}} </div>
{{#if portfolio}}
<a data-action="portfolio" id="portfolio_button" tabindex="0" href="#">{{t 'portfolioButton'}}</a>
<div class="site-portfolio" tabindex="-1"></div>
{{/if}}
<div class="dialog"></div>
<div id="main-container" class="main"></div>
<div class="site-compatibility"></div>
{{#if showDev}}
<div>
  <div class="developer-toolbar ef-layout-grid"></div>
  <button class="btn btn-overlay btn-compact" id="developer_button">Developer Tools</button>
</div>
{{/if}}
